module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_8023.41bd7f71.png";